import { useQuery } from "@tanstack/react-query";
import { summaryApi } from "../../api/summary/summary_api";
import { useSummaryType } from "./summary.types";
/**
 *
 * @param {Function}onSucces
 * @param {Function}onError
 * @param {string}url
 * @param {queryStr}string
 * @param {boolean}enabled
 * @returns {object}
 */
//custom hook which encapsulates useQuery usage and can be used for GET requests
const useSummary = ({
  onSucces,
  onError,
  url,
  queryKey,
  enabled = true,
  refetchIntervalInBackground = false,
  refetchOnWindowFocus = false,
  refetchOnMount = false,
  staleTime = 3000,
}: useSummaryType) => {
  const res = useQuery({
    queryFn: () => summaryApi({ url }),
    onError: (err) => (onError ? onError(err) : ""),
    onSuccess: (data) => (onSucces ? onSucces(data) : ""),
    queryKey: queryKey,
    refetchIntervalInBackground: refetchIntervalInBackground,
    refetchOnWindowFocus: refetchOnWindowFocus,
    refetchOnMount: refetchOnMount,
    staleTime: staleTime,
    enabled: enabled,
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    useErrorBoundary: (err: any) => {
      return err.statusCode >= 500;
    },
  });
  return {
    ...res,
  };
};
export default useSummary;
